import { isUndefined } from '../../predicates/type';
import { isMobileAny } from '../../utils/device';
import { getAppElement } from '../app/utils';
import { hasToolNavigation } from './hasToolNavigation';
import {
	ActiveToolNavigationModule,
	ToolNavigationData,
	ToolNavigationNormalizedData,
	ToolNavigationNormalizedNoData,
} from './types';

export const getInitialActiveModule = ({
	isAdmin,
	adminNavigationItems,
	userNavigationItems,
}: ToolNavigationNormalizedData): null | ActiveToolNavigationModule => {
	const items = isAdmin ? adminNavigationItems : userNavigationItems;

	const activeModule = items.find((item) => item.isActive);

	if (!activeModule) return null;

	const activeChild = activeModule.childNavigationItems.find((child) => child.isActive);

	return {
		moduleName: activeModule.moduleName,
		pageTypeId: activeChild ? activeChild.pageTypeId : activeModule.pageTypeId,
	};
};

export const urlToTestId = (url: string) => {
	if (!url || !url.trim()) return '';

	let normalized = url.charAt(0) === '/' ? url.slice(1) : url;
	normalized = normalized.split('/').join('-');

	return `toolNavigationLink_${normalized}`;
};

export function hasToolNavigationJson() {
	const portalContainer = document.querySelector<HTMLDivElement>('#root');
	let parsedToolNavJson: ToolNavigationData | undefined;

	try {
		parsedToolNavJson = JSON.parse(portalContainer.dataset.toolNavJson) as ToolNavigationData;
	} catch (e) {}

	return portalContainer && portalContainer.dataset.toolNavJson && !isUndefined(parsedToolNavJson);
}

export const getNormalizedData = (): ToolNavigationNormalizedData | ToolNavigationNormalizedNoData => {
	if (!hasToolNavigation()) {
		return {
			hasToolNavigation: false,
		};
	}
	const app = getAppElement();
	const parsedToolNavJson = JSON.parse(app.dataset.toolNavJson) as ToolNavigationData;

	const {
		isAdminModule,
		data: { userModuleNavigation, adminModuleNavigation, footerNavigation, hasFaqNavigation, hasHelpNavigation },
	} = parsedToolNavJson;

	return {
		hasHelpNavigation,
		hasFaqNavigation,
		isAdmin: isAdminModule,
		userNavigationItems: userModuleNavigation,
		adminNavigationItems: adminModuleNavigation,
		footerNavigationItems: footerNavigation,
	};
};

export const getNavItemDataTestId = (moduleName: string) => `toolNavigationItem_${moduleName}`;
export const getPrimaryLinkDataTestId = (moduleName: string) => `toolNavigationLinkPrimary_${moduleName}`;
export const getCollapseButtonDataTestId = (moduleName: string) => `toolNavigationCollapseButton_${moduleName}`;

export function isExpandedInitially() {
	if (isMobileAny) {
		return false;
	}

	return getAppElement().classList.contains('app--tool-navigation-expanded');
}
